import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Lisa ostukorvi

  <span style="color:#85c1dc;">**FI:**</span>
  Lisää ostoskoriin

  <span style="color:#85c1dc;">**RU:**</span>
  Положить в корзину
*/
/* @__NO_SIDE_EFFECTS__ */
const m1094 = msg(
  mf`Lisa ostukorvi`,
  mf`Lisää ostoskoriin`,
  mf`Положить в корзину`,
)

export { m1094 as 'w.module.submission_form.add_basket' }